import React from 'react';
import Icon from '../../../components/AppIcon';


const ProfilePreview = ({ profile, isAntiBiasMode }) => {
  return (
    <div className="bg-card rounded-xl shadow-elevation border border-border">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-foreground">Profile Preview</h3>
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Eye" size={16} />
            <span>How employers see you</span>
          </div>
        </div>
      </div>
      <div className="p-6">
        <div className="flex items-start space-x-4 mb-6">
          <div className="h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="User" size={32} className="text-primary" />
          </div>
          <div className="flex-1">
            <h4 className="text-xl font-semibold text-foreground mb-1">
              Anonymous Candidate #{profile?.candidateId}
            </h4>
            <p className="text-muted-foreground mb-2">{profile?.title}</p>
            <div className="flex items-center space-x-4 text-sm text-muted-foreground">
              <div className="flex items-center space-x-1">
                <Icon name="MapPin" size={14} />
                <span>{profile?.location}</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="Clock" size={14} />
                <span>{profile?.experience}</span>
              </div>
              {!isAntiBiasMode && profile?.age && (
                <div className="flex items-center space-x-1">
                  <Icon name="Calendar" size={14} />
                  <span>{profile?.age} years</span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <h5 className="text-sm font-medium text-foreground mb-2">Skills</h5>
            <div className="flex flex-wrap gap-2">
              {profile?.skills?.map((skill, index) => (
                <span 
                  key={index}
                  className="px-3 py-1 bg-primary/10 text-primary text-sm rounded-full"
                >
                  {skill?.name} • {skill?.level}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h5 className="text-sm font-medium text-foreground mb-2">Education</h5>
            <p className="text-sm text-muted-foreground">{profile?.education}</p>
          </div>

          <div>
            <h5 className="text-sm font-medium text-foreground mb-2">Languages</h5>
            <div className="flex flex-wrap gap-2">
              {profile?.languages?.map((lang, index) => (
                <span 
                  key={index}
                  className="px-2 py-1 bg-muted text-muted-foreground text-sm rounded"
                >
                  {lang?.language} ({lang?.level})
                </span>
              ))}
            </div>
          </div>

          <div>
            <h5 className="text-sm font-medium text-foreground mb-2">Availability</h5>
            <div className="flex items-center space-x-2">
              <div className={`h-2 w-2 rounded-full ${
                profile?.availability === 'Available' ? 'bg-success' : 
                profile?.availability === 'Busy' ? 'bg-warning' : 'bg-destructive'
              }`} />
              <span className="text-sm text-muted-foreground">{profile?.availability}</span>
            </div>
          </div>

          {profile?.salaryRange && (
            <div>
              <h5 className="text-sm font-medium text-foreground mb-2">Salary Expectation</h5>
              <p className="text-sm text-muted-foreground">{profile?.salaryRange} NOK/year</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfilePreview;